module.exports = __webpack_public_path__ + "img/21_74.759beb90.png";